import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtherCatalogsService {
  private url: string;

  constructor(
    private http: HttpClient
  ) {
    this.url = environment.services_url;
  }

  //
  getListSchema = () => {
    return this.http.get(`${this.url}/CatCommissionSchema/Catalog`)
      .pipe(
        map((resp: any) => resp)
      );
  }
  getListSchemaByEmployeeJob = (employeeJobId: string) => {
    return this.http.get(`${this.url}/CatCommissionSchema/ListByEmployeeJob?employeeJobId=${employeeJobId}`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getCreatedSchemas = () => {
    return this.http.get(`${this.url}/CommissionProductEmployeeJobWH/ListCreatedSchemas`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getCatalogoMotivo = () => {
    return this.http.get(`${this.url}/CatComponent/getCatalogoMotivo`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getFigurasRetencion = () => {
    return this.http.get(`${this.url}/CatComponent/getFigurasRetencion`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  getAreaByRoleId = (roleId: string) => {
    switch (roleId) {
      case 'COMI_FINANZAS':
        return 'Finanzas';
      case 'COMI_COMERCIAL':
        return 'Comercial';
      case 'COMI_OPERACIONES':
        return 'Operaciones';
      case 'COMI_AUDITORIA':
        return 'Auditoría';
      case 'COMI_SUPER_ADMIN':
        return 'Sistemas';
      default:
        return 'Desconocida';
    }
  }
}